import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      trainingPlanMap: {}
    };
  },
  mutations: {
    /** 设置训练计划 */
    setTrainingPlanMap: function setTrainingPlanMap(state, _a) {
      var activityId = _a.activityId,
          weekNo = _a.weekNo,
          data = _a.data; // 实际周数从0开始计数

      Vue.set(state.trainingPlanMap, activityId + "_" + weekNo, data);
    }
  },
  actions: {
    /**
     * 获取训练计划
     * @param activityId 活动id
     * @param weekNo 第几周
     */
    getTrainingPlan: function getTrainingPlan(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          weekNo = _b.weekNo;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('api/v1/medal/training_plan_list', {
                params: {
                  activity_id: activityId,
                  week_no: weekNo + 1
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTrainingPlanMap', {
                  activityId: activityId,
                  weekNo: weekNo,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 选择训练计划
     * @param activityId 活动id
     * @param trainLevel 选择的训练计划等级
     */
    chooseTrainLevel: function chooseTrainLevel(context, _a) {
      var activityId = _a.activityId,
          trainLevel = _a.trainLevel;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('api/v1/medal/choose_train_level', {
                activity_id: activityId,
                train_level: trainLevel
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;